import type { VoidFunctionComponent } from 'react';

import { Badge, BadgeColors } from '../../generic';
import Tooltip from '../../generic/Tooltip';
import type { ExceptionIgnoreScope } from '../../../../shared/issuesV2';

import { getBadgeTextForIgnoreScope } from './utils';

import styles from './IssueExceptionsTable.module.less';

type Props = {
  ignoreScope: ExceptionIgnoreScope;
  projectTitle: string | null;
  policyTitle: string | null;
  shouldOutlineBadge?: boolean;
};

/**
 * Provides a human readable ignore scope as a badge.
 *
 * @param {Props} props Component props
 * @param {ExceptionIgnoreScope} props.ignoreScope Ignore scope
 * @param {string | null} props.projectTitle Project title of the exception
 * @param {string | null} props.policyTitle Policy title of the exception
 * @param {boolean} [props.shouldOutlineBadge] Whether to use a small badge
 */
const IssueExceptionsTableIgnoreScopeBadge: VoidFunctionComponent<Props> = ({
  ignoreScope,
  projectTitle,
  policyTitle,
  shouldOutlineBadge = false,
}) => (
  <Tooltip id={`exception-project-tooltip-${projectTitle || policyTitle}`} tooltip={projectTitle || policyTitle}>
    <span className="inline-block">
      <span className={styles.scopeBadge}>
        <Badge
          color={shouldOutlineBadge ? BadgeColors.DarkGray : BadgeColors.LightGray}
          fullWidth={!shouldOutlineBadge}
          outline={shouldOutlineBadge}
        >
          {getBadgeTextForIgnoreScope(ignoreScope)}
        </Badge>
      </span>
      {!shouldOutlineBadge ? projectTitle || policyTitle : null}
    </span>
  </Tooltip>
);

export default IssueExceptionsTableIgnoreScopeBadge;
